import {Col, Row} from "antd";
import {CustomerOrdersFilter} from "./filter";
import {StyledServiceOrderListHeaderTitle} from "../../../header/styles";

export function CustomerOrderListHeader() {
  return (
    <Row gutter={16} align="middle">
      <Col span={12}>
        <StyledServiceOrderListHeaderTitle>My orders</StyledServiceOrderListHeaderTitle>
      </Col>
      <Col span={12}>
        <CustomerOrdersFilter />
      </Col>
    </Row>
  );
}
